/**
 * Language configuration with all language-specific content
 * This is the single source of truth for language data
 */
export const LANGUAGES = {
    hindi: {
        key: 'hindi',
        label: 'Hindi',
        consentText: 'मैं इस आवाज का मालिक हूं और मैं सिंथेटिक आवाज मॉडल बनाने के लिए Google को इस आवाज का उपयोग करने की सहमति देता हूं',
        referenceScript: 'नमस्ते, मैं आपका टाटा माइलेंज सारथी। सही RPM और टॉप गियर से ईंधन बचता है। सुरक्षित ड्राइव करें।',
    },
    marathi: {
        key: 'marathi',
        label: 'Marathi',
        consentText: 'मी या आवाजाचा मालक आहे आणि सिंथेटिक व्हॉइस मॉडेल तयार करण्यासाठी हा आवाज वापरण्यासाठी मी Google ला संमती देतो',
        referenceScript: 'नमस्कार, मी तुमचा टाटा मायलेज सारथी. योग्य RPM आणि टॉप गिअरने इंधन बचत होते. सुरक्षितपणे चला.',
    },
    tamil: {
        key: 'tamil',
        label: 'Tamil',
        consentText: 'நான் இந்த குரலின் உரிமையாளர் மற்றும் செயற்கை குரல் மாதிரியை உருவாக்க இந்த குரலை பயன்படுத்த குகல்க்கு நான் ஒப்புக்கொள்கிறேன்.',
        referenceScript: 'வணக்கம், நான் உங்கள் டாடா மைலேஜ் சாரதி. சரியான RPM, டாப் கியர் எரிபொருள் சேமிக்கிறது. பாதுகாப்பாக ஓடுங்கள்.',
    },
    kannada: {
        key: 'kannada',
        label: 'Kannada',
        consentText: 'ನಾನು ಈ ಧ್ವನಿಯ ಮಾಲಿಕ ಮತ್ತು ಸಂಶ್ಲೇಷಿತ ಧ್ವನಿ ಮಾದರಿಯನ್ನು ರಚಿಸಲು ಈ ಧ್ವನಿಯನ್ನು ಬಳಸಿಕೊಂಡುಗೂಗಲ್ ಗೆ ನಾನು ಸಮ್ಮತಿಸುತ್ತೇನೆ.',
        referenceScript: 'ನಮಸ್ಕಾರ, ನಾನು ನಿಮ್ಮ ಟಾಟಾ ಮೈಲೇಜ್ ಸಾರಥಿ. ಸರಿಯಾದ RPM, ಟಾಪ್ ಗೇರ್ ಇಂಧನ ಉಳಿಸಿದೆ. ಸುರಕ್ಷಿತವಾಗಿ ಓಡಿಸಿ.',
    },
    telugu: {
        key: 'telugu',
        label: 'Telugu',
        consentText: 'నేను ఈ వాయిస్ యజమానిని మరియు సింతటిక్ వాయిస్ మోడల్ ని రూపొందించడానికి ఈ వాయిస్ ని ఉపయోగించడానికి googleకి నేను సమ్మతిస్తున్నాను.',
        referenceScript: 'నమస్కారం, నేను మీ టాటా మైలేజ్ సారథి. సరైన RPM, టాప్ గియర్ ఇంధనం ఆదా చేస్తుంది. భద్రంగా డ్రైవ్ చేయండి.',
    },
    bengali: {
        key: 'bengali',
        label: 'Bengali',
        consentText: 'আমি এই ভয়েসের মালিক এবং আমি একটি সিন্থেটিক ভয়েস মডেল তৈরি করতে এই ভয়েস ব্যবহার করে Google-এর সাথে সম্মতি দিচ্ছি।',
        referenceScript: 'নমস্কার, আমি আপনার টাটা মাইলেজ সারথি। সঠিক RPM ও টপ গিয়ার জ্বালানি সাশ্রয় করে। নিরাপদে চালান।',
    },
    malayalam: {
        key: 'malayalam',
        label: 'Malayalam',
        consentText: 'ഈ ശബ്ദത്തിന്റെ ഉടമ ഞാനാണ്, ഒരു സിന്തറ്റിക് വോയ്‌സ് മോഡൽ സൃഷ്ടിക്കാൻ ഈ ശബ്‌ദം ഉപയോഗിക്കുന്നതിന് ഞാൻ Google-ന് സമ്മതം നൽകുന്നു.',
        referenceScript: 'നമസ്കാരം, ഞാൻ നിങ്ങളുടെ ടാറ്റാ മൈലേജ് സാരഥി. ശരിയായ RPM, ടോപ് ഗിയർ ഇന്ധനം ലാഭിക്കുന്നു. സുരക്ഷിതമായി ഓടിക്കുക.',
    },
};
// Get array of all languages (for dropdown options)
export const LANGUAGE_OPTIONS = Object.values(LANGUAGES);
// Get array of language keys only
export const LANGUAGE_KEYS = Object.keys(LANGUAGES);
